// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Renders accessory options (either as a select list or a <ul>)
 */
M.View.ProductDetails.AccessoryPicker = Backbone.View.extend({
  className: 'accessoryPicker',
  template: M.Template.ProductDetail.AccessoryPicker,
  events: {
    'click .accessoryOption': 'accessoryOptionClick'
  },

  initialize: function() {
    if (!this.collection) {
      M.required(this.options.accessoryOptionsJson);
      this.collection = new M.Collection.ProductDetails.Accessories(
        this.options.accessoryOptionsJson);
    }

    // TODO: <select> list template version
    if (this.options.template) {
      this.template = this.options.template;
    }

    var that = this;
    this.collection.bind('selected_sku', function() {
      that.highlightSelectedElement();
    });
  },

  render: function() {
    this.$el = $(this.el);
    this.$el.empty();

    var templateVariables = {
      accessories: this.collection.models
    };
    this.$el.html(this.template(templateVariables));

    return this;
  },

  /**
   * Deselect any selected options.
   */
  deSelect: function() {
    this.$el.find('.accessoryOption').removeClass('active');
    this.collection.select(null);
  },

  /**
   * Visually highlight an option.
   */
  highlightSelectedElement: function() {
    var selectedModel = this.collection.getSelected();
    var $option = this.$el.find(
      '.accessoryOption[data-id=' + selectedModel.get('id') + ']');
    $option.addClass('active');
  },

  accessoryOptionClick: function(e) {
    var clickedElement = $(e.currentTarget);

    // Prevent default click action if the link is already selected.
    if (clickedElement.hasClass('active')) {
      return false;
    }

    this.$el.find('.accessoryOption').removeClass('active');
    clickedElement.addClass('active');
    var selectedModel = this.collection.get(clickedElement.data('id'));
    this.collection.select(selectedModel);
    this.trigger('accessory_option_clicked');
  }
});
